import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCameraFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.591 3.02A2.24 2.24 0 0 1 7.463 2h1.074a2.24 2.24 0 0 1 1.872 1.02l.131.201c.25.383.672.612 1.123.612h.087c1.243 0 2.25 1.026 2.25 2.292v4.583C14 11.974 12.993 13 11.75 13h-7.5C3.007 13 2 11.974 2 10.708V6.125c0-1.266 1.007-2.292 2.25-2.292h.087c.451 0 .873-.23 1.123-.612zM8 5.667c-1.16 0-2.1.957-2.1 2.139 0 1.18.94 2.138 2.1 2.138s2.1-.957 2.1-2.138-.94-2.14-2.1-2.14"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCameraFilled);
export default ForwardRef;
